import * as _ from 'lodash';
import { FETCH_CONSTANTS_SUCCEEDED } from './list.actions';
import {ActivatedRoute} from "@angular/router";
import {AppInjector} from "../../../app-injector";

export const list = (state = {}, action) => {
  switch (action.type) {
    case FETCH_CONSTANTS_SUCCEEDED:
      const activatedRoute = AppInjector.get(ActivatedRoute);
      const url = activatedRoute.snapshot.url;
      if (activatedRoute.snapshot.queryParams.filter_order_status) {
        const status = activatedRoute.snapshot.queryParams.filter_order_status.split(',');
        return {
          fetched: true,
          items: {
            ...Object.keys(action.data).reduce((obj, curVal) => {
              obj[curVal] = action.data[curVal];
              return obj;
            }, {}),
            ORDER_STATUS: _.map(action.data.ORDER_STATUS, item => {
            const result = _.find(status, i => i === item.key);
            if (result) {
              return _.assign(item, {
                isChecked: true
              });
            }
            return _.assign(item, {
              isChecked: false
            });
          })
          },
          objects: {
            ...action.object
          }
        };
      } else {
        return {
          fetched: true,
          items: {
            ...action.data
          },
          objects: {
            ...action.object
          }
        };
      }

    default:
      return state;
  }
};
